import { Amplify } from "aws-amplify";
import { newColors } from "constants/newColors";
import { LoadingStateProvider } from "providers/LoadingProvider";
import React from "react";
import ReactDOM from "react-dom";
import { createGlobalStyle } from "styled-components";
import { Reset } from "styled-reset";

import App from "./App";
import awsconfig from "./aws-exports";
import reportWebVitals from "./reportWebVitals";

Amplify.configure(awsconfig);

const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
  }
  body {
    height: 100vh;
    background: ${newColors.background};
    font-family:
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    Meiryo,
    sans-serif;
  }
  input, textarea {
  font-family : inherit;
}

  @media print {
    .ipc_header{display: none;}
    .release-scroll{overflow-y: visible;}
    body {
      -webkit-print-color-adjust: exact;
      background: none;
    }
  }

  #root {
    height: 100%;
  }

  table, th, td {
  outline: none;
}
`;

ReactDOM.render(
  <React.StrictMode>
    <Reset />
    <GlobalStyle />
    <LoadingStateProvider>
      <App />
    </LoadingStateProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
